import $ from "jquery";

class Menu {
    run() {
        this.setMenuHeight();
        this.menuToggler();
    }

    setMenuHeight() {
        let navigation = document.querySelector('header') 
        
        document.body.style.setProperty('--menu-height', `${navigation.clientHeight}px`);

        document.addEventListener('resize', () => {
            document.body.style.setProperty('--menu-height', `${navigation.clientHeight}px`);
        });
    }

    menuToggler() {
        const btnMainMenu = $('#btnMenu');
        const btnProductMenu = $('#btnProduct');
        const mainMenu = $('#menu');
        const productMenu = $('#product');

        $(btnMainMenu).on('click', function(){

            if($('header').hasClass('productMenu')){
                $('header').removeClass('active productMenu');
                $(productMenu).removeClass('active');
                $('body').removeClass('overflow-hidden');
            } else {
                $("html, body").animate({ scrollTop: 0 }, "fast");
                $('header').toggleClass('active mainMenu');
                $(mainMenu).toggleClass('active');
                $('body').toggleClass('overflow-hidden');
            }
        });

        $(btnProductMenu).on('click', function(){
            $("html, body").animate({ scrollTop: 0 }, "fast");
            $('header').addClass('active productMenu');
            $(productMenu).addClass('active');
            $('body').addClass('overflow-hidden');

        });

        $(window).scroll(function() {
            var scroll = $(window).scrollTop();

            //>=, not <=
            if (scroll > 100) {
                $(".header").addClass("scrolled");
                $('#btnBackTop').addClass('active');
            }
            else{
                $(".header").removeClass("scrolled");
                $('#btnBackTop').removeClass('active');
            }
        });

    }
}

const menu = new Menu();
export default menu;
